<template>
	<v-app>
		<v-toolbar app dark color="primary">
			<v-toolbar-title class="headline">
				<span>Have I Borrowed?</span>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn dark v-show="loggedIn" @click="logout">Logout <span v-if="countdownEnabled">({{ countdown }})</span></v-btn>
		</v-toolbar>
		<Loading />
		<Error />
		<v-content>
			<router-view />
		</v-content>
	</v-app>
</template>

<script>
import Loading from './components/Loading'
import Error from './components/Error'
import Login from './views/Login'

export default {
	name: 'App',
	components: {
		Loading,
		Error,
		Login
	},
	data ( ) {
		return {
			countdownEnabled: false,
			defaultCountdown: 20,
			countdown: 20,
			timeout: null
		}
	},
	mounted( ) {
		// check for timeout
		if ( this.$route.query.hasOwnProperty( 't' ) ) {
			if ( !isNaN( this.$route.query.t ) ) {
				var value = Number( this.$route.query.t );
				if ( value > 0 ) {
					this.defaultCountdown = Number( this.$route.query.t );
					this.countdownEnabled = true;
					localStorage.countdown = this.defaultCountdown;
				} else {
					localStorage.removeItem( 'countdown' );
				}
			}
		} else if ( localStorage.countdown ) {
			if ( !isNaN( localStorage.countdown ) ) {
				var value = Number( localStorage.countdown );
				if ( value > 0 ) {
					this.defaultCountdown = Number( localStorage.countdown );
					this.countdownEnabled = true;
				}
			}
		}
		this.countdown = this.defaultCountdown;
		// check for beta flag
		if ( this.$route.query.hasOwnProperty( 'beta' ) ) {
			if ( !isNaN( this.$route.query.beta ) ) {
				var value = Number( this.$route.query.beta );
				if ( value == 1 ) {
					this.$store.dispatch( 'enableBeta' );
				}
			}
		}
	},
	computed: {
		loggedIn( ) {
			return this.$store.state.patron.loggedIn;
		},

	},
    watch: {
        loggedIn( updated, orginial ) {
            if ( !updated ) {
                this.$router.push( { name: 'login' } );
            }
		},
		countdown( updated, orginial ) {
			if ( updated == 0 ) {
				clearTimeout( this.timeout );
				this.countdown = this.defaultCountdown;
				this.logout( );
			}
		},
		isAppIdle( updated, orginial ) {
			if ( this.loggedIn && this.countdownEnabled ) {
				if ( updated ) {
					this.timeout = setInterval( ( ) => {
						this.countdown -= 1;
					}, 1000 );
				} else {
					clearInterval( this.timeout );
					this.countdown = this.defaultCountdown;
				}
			}
		},
    },
	methods: {
		logout( ) {
			this.$store.dispatch( 'patron/logout' );
		},
	}
}
</script>
